export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG"
export const CHANGE_USER_NAME = "CHANGE_USER_NAME"
export const CHANGE_PHOTO_URL = "CHANGE_PHOTO_URL"
;